import React, { useEffect, useRef } from 'react';

export const EnergyField = ({ lines = 5, particleCount = 16, showGrid = true }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext('2d');
    const m = { raf: 0, active: true };

    const setSize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    setSize();
    window.addEventListener('resize', setSize);

    const draw = (t) => {
      if (!m.active) return;
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      for (let i = 0; i < lines; i += 1) {
        const yBase = (h / (lines + 1)) * (i + 1);
        const amp = 16 + i * 7;
        ctx.beginPath();
        for (let x = 0; x <= w; x += 14) {
          const y =
            yBase +
            Math.sin(x * 0.0042 + t * 0.0004 + i * 0.7) * amp +
            Math.sin(x * 0.012 + t * 0.00026) * (amp * 0.35);
          if (x === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.strokeStyle = `rgba(30,143,137,${0.05 + i * 0.008})`;
        ctx.lineWidth = 1;
        ctx.stroke();
      }
      m.raf = requestAnimationFrame(() => draw(t + 16));
    };
    m.raf = requestAnimationFrame(() => draw(0));

    return () => {
      m.active = false;
      cancelAnimationFrame(m.raf);
      window.removeEventListener('resize', setSize);
    };
  }, [lines]);

  return (
    <div className="atmos-wrap" aria-hidden="true">
      <canvas ref={canvasRef} className="atmos-canvas" />
      {showGrid && <div className="atmos-grid" />}
      <div className="atmos-fog atmos-fog-1" />
      <div className="atmos-fog atmos-fog-2" />
      <div className="particles">
        {Array.from({ length: particleCount }).map((_, i) => {
          const left = (i * 6.1 + (i % 4) * 2.5) % 100;
          const duration = 11 + (i % 6) * 2.5;
          const delay = (i % 9) * 1.6;
          return (
            <span
              key={i}
              style={{ left: `${left}%`, animationDuration: `${duration}s`, animationDelay: `${delay}s` }}
            />
          );
        })}
      </div>
    </div>
  );
};

export const Logo = ({ className = '' }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <span className="relative flex items-center justify-center w-2.5 h-2.5">
      <span className="absolute inset-0 rounded-full bg-[#1E8F89]" />
      <span className="absolute -inset-1 rounded-full bg-[#1E8F89]/30 blur-[3px]" />
    </span>
    <span className="font-mono-tech text-[0.78rem] tracking-[0.32em] text-[#E2E4E9] uppercase">
      Free<span className="text-[#1E8F89]">Field</span>Flow
    </span>
  </div>
);

export default EnergyField;
